import React from "react";

const GooglePlay = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="134.938"
      height="40.063"
      locale="en-us"
      class="UgVFMaRGgeS8ZLK4VHuP"
    >
      <defs>
        <linearGradient
          id="a"
          gradientUnits="userSpaceOnUse"
          x1="21.8"
          y1="173.29"
          x2="5.017"
          y2="156.508"
          gradientTransform="matrix(1 0 0 -1 0 182)"
        >
          <stop offset="0" stop-color="#00a0ff"></stop>
          <stop offset=".007" stop-color="#00a1ff"></stop>
          <stop offset=".26" stop-color="#00beff"></stop>
          <stop offset=".512" stop-color="#00d2ff"></stop>
          <stop offset=".76" stop-color="#00dfff"></stop>
          <stop offset="1" stop-color="#00e3ff"></stop>
        </linearGradient>
        <linearGradient
          id="a"
          gradientUnits="userSpaceOnUse"
          x1="21.8"
          y1="173.29"
          x2="5.017"
          y2="156.508"
          gradientTransform="matrix(1 0 0 -1 0 182)"
        >
          <stop offset="0" stop-color="#00a0ff"></stop>
          <stop offset=".007" stop-color="#00a1ff"></stop>
          <stop offset=".26" stop-color="#00beff"></stop>
          <stop offset=".512" stop-color="#00d2ff"></stop>
          <stop offset=".76" stop-color="#00dfff"></stop>
          <stop offset="1" stop-color="#00e3ff"></stop>
        </linearGradient>
        <linearGradient
          id="b"
          gradientUnits="userSpaceOnUse"
          x1="33.834"
          y1="161.999"
          x2="9.637"
          y2="161.999"
          gradientTransform="matrix(1 0 0 -1 0 182)"
        >
          <stop offset="0" stop-color="#ffe000"></stop>
          <stop offset=".409" stop-color="#ffbd00"></stop>
          <stop offset=".775" stop-color="orange"></stop>
          <stop offset="1" stop-color="#ff9c00"></stop>
        </linearGradient>
        <linearGradient
          id="c"
          gradientUnits="userSpaceOnUse"
          x1="24.827"
          y1="159.704"
          x2="2.069"
          y2="136.946"
          gradientTransform="matrix(1 0 0 -1 0 182)"
        >
          <stop offset="0" stop-color="#ff3a44"></stop>
          <stop offset="1" stop-color="#c31162"></stop>
        </linearGradient>
        <linearGradient
          id="d"
          gradientUnits="userSpaceOnUse"
          x1="7.297"
          y1="181.824"
          x2="17.46"
          y2="171.661"
          gradientTransform="matrix(1 0 0 -1 0 182)"
        >
          <stop offset="0" stop-color="#32a071"></stop>
          <stop offset=".069" stop-color="#2da771"></stop>
          <stop offset=".476" stop-color="#15cf74"></stop>
          <stop offset=".801" stop-color="#06e775"></stop>
          <stop offset="1" stop-color="#00f076"></stop>
        </linearGradient>
      </defs>
      <path fill="none" d="M-10-10h155v60H-10z"></path>
      <path d="M130 40H5c-2.75 0-5-2.25-5-5V5c0-2.75 2.25-5 5-5h125c2.75 0 5 2.25 5 5v30c0 2.75-2.25 5-5 5z"></path>
      <path
        d="M130 .8c2.316 0 4.2 1.884 4.2 4.2v30c0 2.316-1.884 4.2-4.2 4.2H5A4.205 4.205 0 01.8 35V5C.8 2.684 2.684.8 5 .8h125m0-.8H5C2.25 0 0 2.25 0 5v30c0 2.75 2.25 5 5 5h125c2.75 0 5-2.25 5-5V5c0-2.75-2.25-5-5-5z"
        fill="#A6A6A6"
      ></path>
      <path
        fill="#FFFFFF"
        stroke="#FFFFFF"
        stroke-miterlimit="10"
        stroke-width="0.2px"
        d="M47.418 10.243c0 .838-.248 1.506-.745 2.003-.564.592-1.3.888-2.204.888-.866 0-1.602-.3-2.208-.9-.606-.601-.909-1.346-.909-2.234 0-.889.303-1.633.91-2.233.605-.6 1.34-.901 2.207-.901.43 0 .841.084 1.232.251.39.168.704.391.938.67l-.527.529c-.398-.475-.945-.712-1.643-.712a2.28 2.28 0 00-1.638.666c-.462.444-.692 1.02-.692 1.73s.23 1.286.692 1.73a2.28 2.28 0 001.638.667c.67 0 1.229-.224 1.676-.67.29-.291.458-.696.503-1.216h-2.179v-.72h2.907c.029.156.042.307.042.452zm4.61-2.506h-2.733V9.64h2.464v.72h-2.464v1.903h2.733V13h-3.503V7h3.503v.737zM55.279 13h-.772V7.737h-1.676V7h4.123v.737H55.28V13zm4.659 0V7h.77v6h-.77zm4.19 0h-.771V7.737H61.68V7h4.123v.737h-1.676V13zm9.482-.775c-.59.606-1.324.909-2.2.909-.878 0-1.611-.303-2.2-.91-.59-.605-.884-1.347-.884-2.224s.294-1.619.884-2.225c.589-.606 1.322-.91 2.2-.91.871 0 1.603.305 2.195.914.592.61.888 1.35.888 2.221 0 .877-.295 1.619-.884 2.225zm-3.83-.503c.444.45.987.675 1.63.675a2.2 2.2 0 001.629-.675c.444-.45.667-1.024.667-1.722s-.223-1.272-.667-1.722a2.201 2.201 0 00-1.63-.674c-.642 0-1.185.224-1.63.674-.443.45-.666 1.024-.666 1.722s.223 1.273.666 1.722zM75.575 13V7h.939l2.916 4.668h.033l-.033-1.157v-3.51h.771v6h-.805l-3.05-4.895h-.034l.034 1.157V13h-.77z"
      ></path>
      <path
        d="M68.136 21.752c-2.352 0-4.27 1.788-4.27 4.253 0 2.449 1.918 4.253 4.27 4.253 2.352 0 4.27-1.804 4.27-4.253 0-2.465-1.918-4.253-4.27-4.253zm0 6.83c-1.289 0-2.4-1.063-2.4-2.577 0-1.53 1.111-2.578 2.4-2.578s2.4 1.047 2.4 2.578c0 1.514-1.111 2.578-2.4 2.578zm-9.314-6.83c-2.352 0-4.269 1.788-4.269 4.253 0 2.449 1.917 4.253 4.27 4.253 2.351 0 4.269-1.804 4.269-4.253 0-2.465-1.918-4.253-4.27-4.253zm0 6.83c-1.288 0-2.4-1.063-2.4-2.577 0-1.53 1.112-2.578 2.4-2.578 1.29 0 2.4 1.047 2.4 2.578 0 1.514-1.11 2.578-2.4 2.578zm-11.078-5.525v1.804h4.317c-.129 1.015-.467 1.756-.983 2.272-.628.628-1.61 1.32-3.334 1.32-2.659 0-4.737-2.142-4.737-4.8s2.078-4.801 4.737-4.801c1.434 0 2.48.564 3.254 1.289l1.273-1.273c-1.08-1.031-2.514-1.82-4.527-1.82-3.641 0-6.702 2.964-6.702 6.605 0 3.64 3.06 6.605 6.702 6.605 1.965 0 3.447-.644 4.607-1.853 1.192-1.192 1.563-2.867 1.563-4.22 0-.42-.032-.806-.097-1.128h-6.073zm45.308 1.401c-.355-.95-1.434-2.706-3.641-2.706-2.191 0-4.012 1.724-4.012 4.253 0 2.384 1.805 4.253 4.221 4.253 1.95 0 3.077-1.192 3.545-1.885l-1.45-.967c-.484.71-1.144 1.177-2.095 1.177-.95 0-1.627-.436-2.062-1.29l5.687-2.351-.193-.484zm-5.8 1.418c-.048-1.643 1.273-2.481 2.223-2.481.741 0 1.37.37 1.58.902l-3.803 1.579zM82.628 30h1.87V17.5h-1.87V30zm-3.06-7.298h-.065c-.419-.5-1.224-.95-2.24-.95-2.126 0-4.075 1.869-4.075 4.269 0 2.384 1.95 4.237 4.076 4.237 1.015 0 1.82-.451 2.239-.967h.064v.613c0 1.627-.87 2.497-2.271 2.497-1.144 0-1.853-.822-2.143-1.515l-1.627.677c.467 1.128 1.708 2.513 3.77 2.513 2.19 0 4.044-1.289 4.044-4.43v-7.637h-1.773v.693zm-2.143 5.88c-1.289 0-2.368-1.079-2.368-2.561 0-1.498 1.079-2.594 2.368-2.594 1.273 0 2.271 1.096 2.271 2.594 0 1.482-.998 2.562-2.271 2.562zm24.38-11.083h-4.47V30H99.2v-4.736h2.606c2.068 0 4.101-1.497 4.101-3.883s-2.033-3.882-4.101-3.882zm.049 6.025H99.2v-4.285h2.654c1.395 0 2.187 1.155 2.187 2.142 0 .97-.792 2.143-2.187 2.143zm11.532-1.795c-1.351 0-2.75.595-3.33 1.914l1.657.691c.354-.691 1.013-.917 1.705-.917.965 0 1.946.58 1.962 1.609v.128c-.338-.193-1.062-.482-1.946-.482-1.785 0-3.603.981-3.603 2.814 0 1.673 1.464 2.75 3.104 2.75 1.255 0 1.946-.562 2.38-1.222h.065v.965h1.801v-4.792c0-2.22-1.656-3.458-3.795-3.458zm-.226 6.851c-.61 0-1.463-.305-1.463-1.061 0-.965 1.061-1.335 1.978-1.335.82 0 1.206.177 1.705.418a2.262 2.262 0 01-2.22 1.978zm10.583-6.578l-2.139 5.42h-.064l-2.22-5.42h-2.01l3.33 7.575-1.899 4.214h1.946l5.131-11.789h-2.075zM106.936 30h1.866V17.5h-1.866V30z"
        fill="#FFFFFF"
      ></path>
      <linearGradient
        id="a"
        gradientUnits="userSpaceOnUse"
        x1="21.8"
        y1="173.29"
        x2="5.017"
        y2="156.508"
        gradientTransform="matrix(1 0 0 -1 0 182)"
      >
        <stop offset="0" stop-color="#00a0ff"></stop>
        <stop offset=".007" stop-color="#00a1ff"></stop>
        <stop offset=".26" stop-color="#00beff"></stop>
        <stop offset=".512" stop-color="#00d2ff"></stop>
        <stop offset=".76" stop-color="#00dfff"></stop>
        <stop offset="1" stop-color="#00e3ff"></stop>
      </linearGradient>
      <path
        d="M10.435 7.538c-.29.308-.463.786-.463 1.405v22.116c0 .62.172 1.097.463 1.405l.074.072L22.9 20.147v-.292L10.51 7.465l-.074.073z"
        fill='url("#a")'
      ></path>
      <linearGradient
        id="b"
        gradientUnits="userSpaceOnUse"
        x1="33.834"
        y1="161.999"
        x2="9.637"
        y2="161.999"
        gradientTransform="matrix(1 0 0 -1 0 182)"
      >
        <stop offset="0" stop-color="#ffe000"></stop>
        <stop offset=".409" stop-color="#ffbd00"></stop>
        <stop offset=".775" stop-color="orange"></stop>
        <stop offset="1" stop-color="#ff9c00"></stop>
      </linearGradient>
      <path
        d="M27.028 24.279l-4.13-4.132v-.292l4.13-4.13.094.053 4.893 2.78c1.397.794 1.397 2.093 0 2.887l-4.893 2.78-.094.054z"
        fill='url("#b")'
      ></path>
      <linearGradient
        id="c"
        gradientUnits="userSpaceOnUse"
        x1="24.827"
        y1="159.704"
        x2="2.069"
        y2="136.946"
        gradientTransform="matrix(1 0 0 -1 0 182)"
      >
        <stop offset="0" stop-color="#ff3a44"></stop>
        <stop offset="1" stop-color="#c31162"></stop>
      </linearGradient>
      <path
        d="M27.122 24.225l-4.224-4.224-12.463 12.463c.461.488 1.221.548 2.078.061l14.609-8.3"
        fill='url("#c")'
      ></path>
      <linearGradient
        id="d"
        gradientUnits="userSpaceOnUse"
        x1="7.297"
        y1="181.824"
        x2="17.46"
        y2="171.661"
        gradientTransform="matrix(1 0 0 -1 0 182)"
      >
        <stop offset="0" stop-color="#32a071"></stop>
        <stop offset=".069" stop-color="#2da771"></stop>
        <stop offset=".476" stop-color="#15cf74"></stop>
        <stop offset=".801" stop-color="#06e775"></stop>
        <stop offset="1" stop-color="#00f076"></stop>
      </linearGradient>
      <path
        d="M27.122 15.777l-14.609-8.3c-.857-.487-1.617-.427-2.078.061l12.463 12.463 4.224-4.224z"
        fill='url("#d")'
      ></path>
      <path
        d="M27.029 24.132l-14.516 8.247c-.812.462-1.537.43-2.003.011l-.075.075.074.072c.467.419 1.192.45 2.004-.012l14.609-8.3-.093-.093z"
        opacity=".2"
      ></path>
      <path
        opacity=".12"
        d="M10.435 32.318c-.29-.307-.463-.785-.463-1.405v.147c0 .619.172 1.097.463 1.405l.075-.075-.075-.072zm21.58-11.019l-4.986 2.833.093.093 4.893-2.78c.698-.397 1.048-.92 1.048-1.444-.059.474-.415.938-1.048 1.298z"
      ></path>
      <path
        d="M12.513 7.623l19.502 11.08c.633.36.989.824 1.048 1.298 0-.523-.35-1.047-1.048-1.444L12.513 7.477c-1.397-.794-2.54-.134-2.54 1.466v.147c0-1.601 1.143-2.26 2.54-1.467z"
        opacity=".25"
        fill="#fff"
      ></path>
    </svg>
  );
};

export default GooglePlay;
